import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase } from "@/utils/stores/base";

export const usePhysicalPersonReportStore = (ownerResourceId) => {
  const path = `physical-persons/${ownerResourceId}/reports/physical-persons`;
  const storeName = "physicalPersonReport" + ownerResourceId;
  return defineStore(storeName, () => {
    const all = ref([]);
    const { baseFetchAll, watchRemoteResourceChange } = useBase();

    const fetchAll = async (errorCallback) => {
      all.value = await baseFetchAll(path, errorCallback);
    };

    const watchResourceChanges = async (callback) => {
      await watchRemoteResourceChange(storeName, callback);
    };

    return {
      all,
      fetchAll,
      watchResourceChanges
    };
  })();
};
